const testUserData = [
    {
        userNo: '1',
        userId: 'ADMIN 01',
        userName: '김월드',
        userStatus: 'admin',
        userAffiliation: '관저점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '2',
        userId: 'ADMIN 02',
        userName: '이월드',
        userStatus: 'admin',
        userAffiliation: '도안점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '3',
        userId: 'ADMIN 03',
        userName: '박월드',
        userStatus: 'admin',
        userAffiliation: '둔산점',
        userPhone: '010-1111-2222', 
    },
    {
        userNo: '4',
        userId: 'ADMIN 04',
        userName: '최월드',
        userStatus: 'admin',
        userAffiliation: '대덕점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '5',
        userId: 'CLERK 01',
        userName: '김점원',
        userStatus: 'clerk',
        userAffiliation: '관저점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '6',
        userId: 'CLERK 02',
        userName: '이점원',
        userStatus: 'clerk',
        userAffiliation: '도안점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '7',
        userId: 'CLERK 03',
        userName: '박점원',
        userStatus: 'clerk',
        userAffiliation: '둔산점',
        userPhone: '010-1111-2222', 
    },
    {
        userNo: '8',
        userId: 'CLERK 04',
        userName: '최점원',
        userStatus: 'clerk',
        userAffiliation: '대덕점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '9',
        userId: 'WORLD 01',
        userName: '김점주',
        userStatus: 'vendor',
        userAffiliation: '관저점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '10',
        userId: 'WORLD 02',
        userName: '이점주',
        userStatus: 'vendor',
        userAffiliation: '도안점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '11',
        userId: 'WORLD 03',
        userName: '박점주',
        userStatus: 'vendor',
        userAffiliation: '둔산점',
        userPhone: '010-1111-2222',
    },
    {
        userNo: '12',
        userId: 'WORLD 04',
        userName: '최점주',
        userStatus: 'vendor',
        userAffiliation: '대덕점',
        userPhone: '010-1111-2222',
    }
];

export default testUserData;